import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { convertRecurringSchedulePatternToPattern, convertRecurringSchedulesFilter, convertRecurringScheduleStatusToStatus, convertStatusToRecurringScheduleStatus, enrichedRecurringScheduleApiToEnrichedRecurringScheduleEntity, recurringScheduleApiToRecurringScheduleEntity, RecurringScheduleStatus } from '../../entities/RecurringSchedule';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
export class RecurringScheduleClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createRecurringScheduleWithContactsImpl", void 0);
    _defineProperty(this, "getRecurringScheduleImpl", void 0);
    _defineProperty(this, "updateRecurringScheduleImpl", void 0);
    _defineProperty(this, "deleteRecurringScheduleImpl", void 0);
    _defineProperty(this, "queryRecurringSchedulesImpl", void 0);
    _defineProperty(this, "searchRecurringSchedulesImpl", void 0);
    _defineProperty(this, "executeRecurringScheduleImpl", void 0);
    _defineProperty(this, "countRecurringScheduleByStatusImpl", void 0);
    _defineProperty(this, "getEnrichedRecurringScheduleImpl", void 0);
    _defineProperty(this, "queryEnrichedRecurringSchedulesImpl", void 0);
  }
  getServiceNameForLogs() {
    return 'RecurringScheduleClientBase';
  }
  async createRecurringSchedule(newRecurringSchedule, contactIds) {
    try {
      const recurringScheduleData = {
        guidelines: newRecurringSchedule.guidelines,
        pattern: convertRecurringSchedulePatternToPattern(newRecurringSchedule.pattern),
        status: {
          status: convertRecurringScheduleStatusToStatus(newRecurringSchedule.status),
          notes: newRecurringSchedule.notes
        },
        serviceId: newRecurringSchedule.serviceId,
        providerId: newRecurringSchedule.providerId,
        frequency: newRecurringSchedule.frequency
      };
      for (var _len = arguments.length, extraParam = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        extraParam[_key - 2] = arguments[_key];
      }
      const {
        recurringSchedule
      } = await this.request(this.createRecurringScheduleWithContactsImpl({
        recurringSchedule: recurringScheduleData,
        contactIds
      }), ...extraParam);
      return this.convertToEntity(recurringSchedule);
    } catch (error) {
      this.logError('createRecurringSchedule', 'Failed to create recurring schedule', {
        newRecurringSchedule,
        contactIds
      }, error);
      throw error;
    }
  }
  async getRecurringSchedule(recurringScheduleId) {
    try {
      for (var _len2 = arguments.length, extraParam = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        extraParam[_key2 - 1] = arguments[_key2];
      }
      const {
        recurringSchedule
      } = await this.request(this.getRecurringScheduleImpl({
        recurringScheduleId
      }), ...extraParam);
      return this.convertToEntity(recurringSchedule);
    } catch (error) {
      this.logError('getRecurringSchedule', 'Failed to get recurring schedule', {
        recurringScheduleId
      }, error);
      throw error;
    }
  }
  async executeRecurringSchedule(recurringScheduleId) {
    try {
      for (var _len3 = arguments.length, extraParam = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        extraParam[_key3 - 1] = arguments[_key3];
      }
      const {
        actionId
      } = await this.request(this.executeRecurringScheduleImpl({
        recurringScheduleId
      }), ...extraParam);
      if (!actionId) {
        throw new Error('No action created for execute recurring schedule');
      }
      return {
        actionId
      };
    } catch (error) {
      this.logError('executeRecurringSchedule', 'Failed to execute recurring schedule', {
        recurringScheduleId
      }, error);
      throw error;
    }
  }
  async updateRecurringSchedule(recurringScheduleData) {
    try {
      const updateRecurringScheduleRequestData = {
        id: recurringScheduleData.id,
        revision: recurringScheduleData.revision,
        guidelines: recurringScheduleData.guidelines,
        pattern: convertRecurringSchedulePatternToPattern(recurringScheduleData.pattern),
        status: {
          status: convertRecurringScheduleStatusToStatus(recurringScheduleData.status),
          notes: recurringScheduleData.notes
        },
        serviceId: recurringScheduleData.serviceId,
        providerId: recurringScheduleData.providerId,
        frequency: recurringScheduleData.frequency
      };
      for (var _len4 = arguments.length, extraParam = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        extraParam[_key4 - 1] = arguments[_key4];
      }
      const {
        recurringSchedule
      } = await this.request(this.updateRecurringScheduleImpl({
        recurringSchedule: updateRecurringScheduleRequestData,
        fieldMask: ['guidelines', 'pattern', 'status', 'serviceId', 'providerId', 'frequency']
      }), ...extraParam);
      return this.convertToEntity(recurringSchedule);
    } catch (error) {
      this.logError('updateRecurringSchedule', 'Failed to update recurring schedule', {
        recurringScheduleData
      }, error);
      throw error;
    }
  }
  async deleteRecurringSchedule(recurringScheduleId) {
    try {
      for (var _len5 = arguments.length, extraParam = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        extraParam[_key5 - 1] = arguments[_key5];
      }
      await this.request(this.deleteRecurringScheduleImpl({
        recurringScheduleId
      }), ...extraParam);
    } catch (error) {
      this.logError('deleteRecurringSchedule', 'Failed to delete recurring schedule', {
        recurringScheduleId
      }, error);
      throw error;
    }
  }
  async queryRecurringSchedules(query) {
    try {
      for (var _len6 = arguments.length, extraParam = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        extraParam[_key6 - 1] = arguments[_key6];
      }
      const {
        recurringSchedules,
        pagingMetadata
      } = await this.request(this.queryRecurringSchedulesImpl({
        query: {
          ...query,
          ...(query.filter && {
            filter: convertRecurringSchedulesFilter(query.filter)
          })
        }
      }), ...extraParam);
      if (!recurringSchedules) {
        throw new Error('Received invalid recurringSchedules');
      }
      return {
        items: recurringSchedules.map(this.convertToEntity),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryRecurringSchedules', 'Failed to query recurring schedules', {
        query
      }, error);
      throw error;
    }
  }
  async searchRecurringSchedules(search) {
    try {
      for (var _len7 = arguments.length, extraParam = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        extraParam[_key7 - 1] = arguments[_key7];
      }
      const {
        recurringSchedules,
        pagingMetadata
      } = await this.request(this.searchRecurringSchedulesImpl({
        search: {
          ...search,
          filter: search.filter && convertRecurringSchedulesFilter(search.filter)
        }
      }), ...extraParam);
      if (!recurringSchedules) {
        throw new Error('Received invalid recurringSchedules');
      }
      return {
        items: recurringSchedules.map(this.convertToEntity),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('searchRecurringSchedule', 'Failed to search recurring schedules', {
        search
      }, error);
      throw error;
    }
  }
  async countRecurringScheduleByStatus() {
    try {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }
      const {
        statusesCounts
      } = await this.request(this.countRecurringScheduleByStatusImpl({}), ...args);
      if (!statusesCounts) {
        throw new Error('statusesCounts is not an array');
      }
      const initialCounts = Object.values(RecurringScheduleStatus).reduce((acc, status) => ({
        ...acc,
        [status]: 0
      }), {});
      return statusesCounts.reduce((acc, _ref) => {
        let {
          status,
          count = 0
        } = _ref;
        const statusKey = convertStatusToRecurringScheduleStatus(status);
        acc[statusKey] = (acc[statusKey] || 0) + count;
        return acc;
      }, initialCounts);
    } catch (error) {
      this.logError('countRecurringSchedulesByStatus', 'Failed to count recurring schedules by status', {}, error);
      throw error;
    }
  }
  async getEnrichedRecurringSchedule(enrichedRecurringScheduleId) {
    try {
      for (var _len9 = arguments.length, extraParam = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        extraParam[_key9 - 1] = arguments[_key9];
      }
      const {
        enrichedRecurringSchedule
      } = await this.request(this.getEnrichedRecurringScheduleImpl({
        enrichedRecurringScheduleId
      }), ...extraParam);
      return enrichedRecurringScheduleApiToEnrichedRecurringScheduleEntity(enrichedRecurringSchedule);
    } catch (error) {
      this.logError('getEnrichedRecurringSchedule', 'Failed to get enriched recurring schedule', {
        enrichedRecurringScheduleId
      }, error);
      throw error;
    }
  }
  async queryEnrichedRecurringSchedules(query) {
    try {
      for (var _len0 = arguments.length, extraParam = new Array(_len0 > 1 ? _len0 - 1 : 0), _key0 = 1; _key0 < _len0; _key0++) {
        extraParam[_key0 - 1] = arguments[_key0];
      }
      const {
        enrichedRecurringSchedules,
        pagingMetadata
      } = await this.request(this.queryEnrichedRecurringSchedulesImpl({
        query
      }), ...extraParam);
      if (!enrichedRecurringSchedules) {
        throw new Error('Received invalid enrichedRecurringSchedules');
      }
      return {
        items: enrichedRecurringSchedules.map(enrichedRecurringScheduleApiToEnrichedRecurringScheduleEntity),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryEnrichedRecurringSchedules', 'Failed to query enriched recurring schedules', {
        query
      }, error);
      throw error;
    }
  }
  convertToEntity(recurringSchedule) {
    try {
      return recurringScheduleApiToRecurringScheduleEntity(recurringSchedule);
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert RecurringSchedule', {
        recurringSchedule
      }, error);
      throw error;
    }
  }
}
//# sourceMappingURL=RecurringScheduleClientBase.js.map